/** Stripe Checkout links for Copilot / premium plan upgrades. */
export const COPILOT_UPGRADE_STRIPE_MONTHLY_URL =
  "https://buy.stripe.com/fZu28r7c0cSGaJF8qqffy02"

export const COPILOT_UPGRADE_STRIPE_YEARLY_URL =
  "https://buy.stripe.com/5kQaEX7c02e27xt366ffy03";

export const COPILOT_UPGRADE_STRIPE_PLANS = [
  { label: "Monthly", url: COPILOT_UPGRADE_STRIPE_MONTHLY_URL },
  { label: "Yearly", url: COPILOT_UPGRADE_STRIPE_YEARLY_URL },
];

const EXTERNAL_RECORDER_CTA_STYLE =
  "display:inline-block;padding:0.38rem 0.85rem;border-radius:8px;background:#c05621;color:#fff;font-weight:600;font-size:0.72rem;text-decoration:none;cursor:pointer;border:none;";

/** Upgrade button + hidden Monthly/Yearly links for the external recorder popup. */
export function copilotUpgradeBannerHtml() {
  const optionLinks = COPILOT_UPGRADE_STRIPE_PLANS.map(
    (plan) =>
      `<a href="${plan.url}" target="_blank" rel="noopener noreferrer" style="${EXTERNAL_RECORDER_CTA_STYLE}">${plan.label}</a>`,
  ).join("");

  return `<button type="button" id="copilotUpgradeBtn" style="${EXTERNAL_RECORDER_CTA_STYLE}">Upgrade</button>
            <div id="copilotUpgradeOptions" style="display:none;gap:0.5rem;justify-content:center;flex-wrap:wrap;margin-top:0.35rem;">${optionLinks}</div>`;
}

export function openCopilotUpgradeCheckout(url) {
  window.open(url, "_blank", "noopener,noreferrer");
}
